import theme from '@clad-ui/theme';
import { styled } from '@linaria/react';
const {
  space
} = theme;
const inputClasses = "i2nuhcf";
export default inputClasses;
const inputFocusClasses = "i1ejxgio";

/**
 *  @type {React.FC<any>}
 */
const _exp19 = /*#__PURE__*/() => ({
  containerWidth
}) => containerWidth;
const Container = /*#__PURE__*/styled('div')({
  name: "Container",
  class: "c1c6tdpz",
  propsAsIs: false,
  vars: {
    "c1c6tdpz-0": [_exp19()]
  }
});
const Paragraph = /*#__PURE__*/styled('p')({
  name: "Paragraph",
  class: "ptpfjva",
  propsAsIs: false
});

/**
 *  @type {React.FC<any>}
 */
const _exp54 = /*#__PURE__*/() => ({
  paddingRight
}) => paddingRight ? `${paddingRight}px` : space.xxl;
const InputWrapper = /*#__PURE__*/styled('div')({
  name: "InputWrapper",
  class: "ia808s0",
  propsAsIs: false,
  vars: {
    "ia808s0-0": [_exp54()]
  }
});

/**
 * @type {any}
 */
const TooltipWrapper = /*#__PURE__*/styled('div')({
  name: "TooltipWrapper",
  class: "t1gpe3kd",
  propsAsIs: false
});
const VadidationIcon = /*#__PURE__*/styled('div')({
  name: "VadidationIcon",
  class: "v1gi4xix",
  propsAsIs: false
});
const LeftIcon = /*#__PURE__*/styled('div')({
  name: "LeftIcon",
  class: "le2e1f7",
  propsAsIs: false
});
export { inputFocusClasses, InputWrapper, Paragraph, Container, TooltipWrapper, VadidationIcon, LeftIcon };

require("./Input.styles.linaria.module.css");